import { Container, Grid, Typography } from '@mui/material'
import CometChatApp from '../CometChat/CometChatApp'
import { useCallback, useEffect, useState } from 'react'
import { CometChatUIKit } from '@cometchat/chat-uikit-react';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';


export default function ChatView() {
  const { accounts } = useMsal()
  const [uid, setUid] = useState('')
  const [loading, setLoading] = useState(true)
  const [renderedChat, setRenderedChat] = useState(<p></p>)
  console.log(accounts[0].username)

  // Get user's faculty ID to build CometChat's UID
  const getFacultyID = useCallback( async () => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_MAIN_BACKEND_URL}/find-faculty-by-email?email=${accounts[0].username}`,
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_MAIN_BACKEND_TOKEN}`
        }
      })

      setUid(`f${data.id}`) // Since only faculty will be accessing SIS, we can safely assume that the UID prefix will be f (for 'faculty')
    } catch (err) {
      console.log(err)
    }
  }, [accounts, setUid])

  useEffect(() => {
    getFacultyID()
  }, [getFacultyID])

  // Get CometChat context
  useEffect(() => {
    const login = async () => {
      const loggedIn = await CometChatUIKit
        .login(uid)
        .then((user: CometChat.User) => {
          console.log("Login Successful:", { user });
          return user
        })
        .catch((error) => {
          console.log(error)
          return null
        });

      if (loggedIn) setRenderedChat(<CometChatApp />)
      else setRenderedChat(<Typography variant='h5' >Chat is not available for your account. If you believe this is an error, please contact support.</Typography>)
      setLoading(false)
    }

    // Don't even attempt to login if uid has not been set
    if (Boolean(uid)) login()
  }, [uid, setRenderedChat, setLoading])

  return <Container sx={{ height: '100%' }} >
    <Grid container paddingBlock={2} height='100%' >
      {
        loading ?
        <p style={{ color: 'white' }} >Loading...</p>
        :
        renderedChat
      }
    </Grid>
  </Container>
}
